module.exports = "https://cwa.roocdn.com/_next/static/apple-touch-icon.d519a11f.png";